/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Save_ChangesInputs */

const en_profile_save_changes = /** @type {(inputs: Profile_Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save changes`)
};

const es_profile_save_changes = /** @type {(inputs: Profile_Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar cambios`)
};

/**
* | output |
* | --- |
* | "Save changes" |
*
* @param {Profile_Save_ChangesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const profile_save_changes = /** @type {((inputs?: Profile_Save_ChangesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Save_ChangesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_profile_save_changes(inputs)
	return en_profile_save_changes(inputs)
});